import React from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { redirectToExternalSite } from '../../../../Utils/redirections';
import { SocialImagesStyle } from './styled';

export default function SocialImages() {
  return (
    <SocialImagesStyle>
      <img
        loading="lazy"
        onClick={() =>
          redirectToExternalSite('https://www.instagram.com/mylofamily')
        }
        src={images.new_insta}
        alt=""
      />
      <img
        loading="lazy"
        onClick={() =>
          redirectToExternalSite('https://www.facebook.com/myloindia/')
        }
        src={images.new_fb}
        alt=""
      />
      <img
        loading="lazy"
        onClick={() =>
          redirectToExternalSite(
            'https://www.youtube.com/channel/UCP6udSSaBIJ-MFqMNtDNdWw',
          )
        }
        src={images.new_youtube}
        alt=""
      />
      <img
        loading="lazy"
        onClick={() =>
          redirectToExternalSite('https://www.linkedin.com/company/mylofamily/')
        }
        src={images.new_linkedin}
        alt=""
      />
    </SocialImagesStyle>
  );
}
